var map = {
	"./sl-big1.png": 4061,
	"./sl-big2.png": 3818,
	"./sl-big3.png": 3288,
	"./sl-big4.png": 9253,
	"./sl-big5.png": 9320,
	"./sl-big6.png": 2292,
	"./sl-big7.png": 7719,
	"./sl-big8.png": 9812
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7971;